import { render, staticRenderFns } from "./EmailConfirmForm.vue?vue&type=template&id=c5f660ce&scoped=true&"
import script from "./EmailConfirmForm.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmForm.vue?vue&type=style&index=0&id=c5f660ce&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f660ce",
  null
  
)

/* custom blocks */
import block0 from "./EmailConfirmForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports